export function QHpassSignOut(events) {
    QHPass.signOut(function() {
        events.signOutSuccCallback()
    });
}

